import { Component, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { environment } from 'environments/environment';

export interface DialogData {
  voucherPath: any,
  remarks: string,
  property_id: string,
  image: string,
  adPlans: any,
  currentAdPlan: number
}

@Component({
  selector: 'app-bank-payment',
  templateUrl: './bank-payment.component.html',
  styleUrls: ['./bank-payment.component.css']
})
export class BankPaymentComponent {

  imgURL: any

  adPlans = []

  basicInfoForm: FormGroup = new FormGroup({
    voucherPath: new FormControl(null, [Validators.required]),
    remarks: new FormControl('', [Validators.required]),
    property_id: new FormControl('', [Validators.required]),
    currentAdPlan: new FormControl('', [Validators.required])
  })

  constructor(
    public dialogRef: MatDialogRef<BankPaymentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
      if(data.voucherPath){
        this.imgURL = data.image
      }
      delete data['image']
      this.adPlans = data.adPlans
      delete data['adPlans']
      this.basicInfoForm.setValue(data)
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  fileChangeEvent(event: any){
    let image = event.target.files[0]
    var filesize = Math.ceil((parseInt(image.size)/1024)/1024)
    if(filesize <= 8){
      this.basicInfoForm['controls']['voucherPath'].setValue(image)
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); 
      reader.onload = (_event) => { 
        this.imgURL = reader.result; 
      }
    }
  }

  saveBankDepositInfo(){
    if(this.basicInfoForm.valid){
      let basicInfo = this.basicInfoForm.value
      this.dialogRef.close(basicInfo)
    }
  }
}
